export const notQualifiedTypes = {
    FACEBOOK: {},
    LINE: {
        FRIEND: 'LINE_FRIEND',
        ENTERPRISE_MEMBER_BIND: 'ENTERPRISE_MEMBER_BIND'
    },
    ENTERPRISE: {
        CYBERBIZ_EC_MEMBER: 'CYBERBIZ_EC_MEMBER',
        MEMBER_KKBOX: 'ENTERPRISE_MEMBER_KKBOX',
        MEMBER: 'MEMBER'
    },
    QUALIFICATION: {
        NAME_LIST_API: 'QUALIFICATION_NAME_LIST_API',
        MEMBER_ORDER: 'QUALIFICATION_MEMBER_ORDER',
        NEW_REGISTER_MEMBER: 'NEW_REGISTER_MEMBER',
        SUBMIT_REFERRAL_CODE: 'SUBMIT_REFERRAL_CODE',
        MEMBER_TIER: 'QUALIFICATION_MEMBER_TIER',
        TAG_LIMIT: 'TAG_LIMIT',
        ACHIEVEMENT_LEVEL: 'ACHIEVEMENT_LEVEL' // 成就等級
    },
    ENTRIES: {
        REACH_LIMIT: 'ENTRIES_REACH_LIMIT'
    }
};
